import React from "react"
import parse from "html-react-parser"

import { Box, Text } from "UI"
import { useMutation } from "@apollo/react-hooks"
import { TRACK_EVENT } from "helpers/activeCampaign"

import {
  WhiteTeaseImage,
  ContentCardsButton,
  TeaserContainer,
  CustomContentGrid,
  HeaderWrapper,
} from "./styles"
import { navigate } from "gatsby"

const CustomContentCards = ({ heading, items }) => {
  const numberOfItems = items.length

  const [trackEvent] = useMutation(TRACK_EVENT)

  return (
    <Box width={["100%", null]} maxWidth="1160px !important">
      {heading && (
        <HeaderWrapper>
          <Text as="h2" fontSize={[28, null, 36]} textAlign="center">
            {heading}
          </Text>
        </HeaderWrapper>
      )}
      <CustomContentGrid numberOfItems={numberOfItems}>
        {items?.map((item, index) => {
          const {
            description,
            heading,
            image,
            link,
            active_campaign_event_tracking,
            event_type,
          } = item?.card || {}

          const to =
            link?.type === "internal" ? link?.internal_link : link?.custom_link

          return (
            <TeaserContainer key={index}>
              {image?.url && (
                <WhiteTeaseImage
                  fluid={{
                    sourceUrl: image?.url,
                    aspectRatio: 1,
                    sizes: "(max-width: 1024px) 100vw, 550px",
                  }}
                />
              )}
              <Box p={["18px 24px 24px", "32px 24px 24px"]} pb={[32, null, 32]}>
                {heading && (
                  <Text
                    as="h3"
                    fontSize={[16, null, 18]}
                    mb={(description || link?.text) && [(18, null, 14)]}
                    textAlign="center"
                  >
                    {heading && parse(heading)}
                  </Text>
                )}
                {description && (
                  <Text as="p" textAlign="center" mb={[14, null, 16]}>
                    {description && parse(description)}
                  </Text>
                )}
                {link?.text && (
                  <ContentCardsButton
                    mt="auto"
                    to={to || "/"}
                    onClick={
                      active_campaign_event_tracking
                        ? (e) => {
                            console.log(`${event_type} - ${heading} - ${to}`)

                            trackEvent({
                              variables: {
                                email:
                                  localStorage.getItem("activeCampaignEmail") ||
                                  "",
                                data: heading,
                                type: event_type,
                              },
                            })

                            if (link.type === "internal") {
                              navigate(to)
                            } else {
                              window.open(to)
                            }
                          }
                        : null
                    }
                  >
                    {link?.text}
                  </ContentCardsButton>
                )}
              </Box>
            </TeaserContainer>
          )
        })}
      </CustomContentGrid>
    </Box>
  )
}

export default CustomContentCards
